import { RECEIVE_PARTNER_AUTHORIZATION, PartnershipActionTypes } from './partnershipTypes';
import { PartnerAuthorization } from 'models/partnership';

export function receivePartnerAuthorization(partnerAuthorization: PartnerAuthorization): PartnershipActionTypes {
  return {
    type: RECEIVE_PARTNER_AUTHORIZATION,
    partnerAuthorization,
  };
}
